import { Component, ViewChild } from "@angular/core";
import {
    IonicPage,
    ToastController,
    PopoverController,
    Popover,
    ActionSheetController,
    ModalController,
    Modal,
    LoadingController,
    NavParams,
    ActionSheet,
    Content,
} from "ionic-angular";
import { pouchdb2 } from "../../services/pouchdb/pouchdb.service";
import { APIOnLine } from "../../services/api/api.services";
import { PaginaBasica } from "../../models/PaginaBase";
import { Proxy } from "../../services/proxy/proxy.service";
import { NuevoMenuDerechoComponent } from "../../components/nuevo-menu-derecho/nuevo-menu-derecho";
import { ModalCodigoAmonestacionPage } from "../modal-codigo-amonestacion/modal-codigo-amonestacion";
import * as mod from "../../models/otrosAuxiliares";
import { FormControl, NgForm, FormGroup, Validators } from "@angular/forms";
import {
    OtrosAuxiliaresAmonestacionService,
    OtrosAuxiliaresService,
} from "../../services/api/otrosauxiliares.service";
import { forkJoin } from "rxjs/observable/forkJoin";

@IonicPage()
@Component({
    selector: "page-amonestaciones",
    templateUrl: "amonestaciones.html",
})
export class AmonestacionesPage extends PaginaBasica {
    @ViewChild(Content) content: Content;

    //#region Propiedades de la página
    public designacion: Proxy.PrDesignaciones;
    public idEquipo: number;
    licencia: Proxy.PrPersonaAlineable;
    public licencias: Proxy.ListaPrPersonaAlineable;
    public participantes: Proxy.ListaPrParticipacion;
    public participante: Proxy.PrParticipacion;

    public amonestaciones: Proxy.ListaPrAmonestaciones;
    public amonestacion: Proxy.PrAmonestaciones;
    public cambios: Proxy.ListaPrCambios; // Se necesita la lista de cambios para comprobar si un jugador está en el terreno de juego en algún minuto.
    public codigos: Proxy.ListaPrCodigoAmonestacion;
    public codigo: Proxy.PrCodigoAmonestacion;

    public mostrarFormulario: boolean = false;
    public esIncidencia: boolean = false;
    public obligadaParticipacion: boolean = false;
    //#endregion

    // #region Propiedades para Fútbol Sala
    public datosFutbolSala: Proxy.PrFutbolSala;
    public acumuladas: number = 0;
    // #endregion

    // #region Propiedades para amonestaciones de otros auxiliares
    formAuxiliar!: FormGroup;
    mostrarFormularioAuxiliar: boolean = false;
    participanteAuxiliar: mod.ActasParticipacionOtrosAuxiliares;
    // #endregion

    constructor(
        public actionSheetCtrl: ActionSheetController,
        public CFutbolActas: APIOnLine.CFutbolActas,
        public DBService2: pouchdb2.DBService2,
        public loadingCtrl: LoadingController,
        public navParams: NavParams,
        public modalCtrl: ModalController,
        public Persistentes: APIOnLine.Persistentes,
        public popOverCtrl: PopoverController,
        public toastCtrl: ToastController,
        public otrosAuxiliaresService: OtrosAuxiliaresService,
        public otrosAuxiliaresAmonestacionService: OtrosAuxiliaresAmonestacionService
    ) {
        super(loadingCtrl, toastCtrl);
    }

    ionViewDidLoad() {
        console.log("--- ENTRO EN LA PÁGINA: AMONESTACIONES ---");

        this.esIncidencia =
            this.navParams.get("esIncidencia") != null
                ? <boolean>this.navParams.get("esIncidencia")
                : false;
        this.Persistentes.SetEsIncidencias(this.esIncidencia);
        this.designacion = this.Persistentes.GetDesignacion();
        this.idEquipo = this.Persistentes.GetIdEquipo();

        this.MostrarOcultarCarga(false, "cargando amonestaciones");

        this.licencias = new Proxy.ListaPrPersonaAlineable(
            this.CFutbolActas,
            this.DBService2,
            this.Persistentes,
            this.designacion,
            this.idEquipo
        );
        this.participantes = new Proxy.ListaPrParticipacion(
            this.CFutbolActas,
            this.DBService2,
            this.Persistentes,
            this.toastCtrl,
            this.designacion,
            this.idEquipo
        );
        this.amonestaciones = new Proxy.ListaPrAmonestaciones(
            this.CFutbolActas,
            this.DBService2,
            this.Persistentes,
            this.toastCtrl,
            this.designacion,
            this.idEquipo
        );
        this.cambios = new Proxy.ListaPrCambios(
            this.CFutbolActas,
            this.DBService2,
            this.Persistentes,
            this.toastCtrl,
            this.designacion,
            this.idEquipo
        );
        this.codigos = new Proxy.ListaPrCodigoAmonestacion(
            this.CFutbolActas,
            this.DBService2,
            this.Persistentes,
            this.toastCtrl,
            this.designacion,
            this.idEquipo
        );
        this.datosFutbolSala = new Proxy.PrFutbolSala(
            this.CFutbolActas,
            this.DBService2,
            this.Persistentes,
            this.designacion,
            this.idEquipo
        );

        this.participantes
            .CargarListaParticipacion()
            .then((resultado: boolean) => {
                return this.licencias.ObtenerAlineables(true, true, true);
            })
            .then((resultado: boolean) => {
                return this.amonestaciones.CargarAmonestaciones(
                    this.esIncidencia
                );
            })
            .then((resultado: boolean) => {
                return this.cambios.CargarCambios();
            })
            .then((resultado: boolean) => {
                return this.codigos.CargarCodigosAmonestacion();
            })
            .then((resultado: boolean) => {
                // Se comprueba si la competición tiene participación obligatoria
                this.obligadaParticipacion =
                    this.designacion.Configuracion.obligadaParticipacion;

                // En el caso de que sea un partido de fútbol sala, se carga su información relacionada
                if (this.designacion.Configuracion.esFutbolSala) {
                    this.datosFutbolSala
                        .Cargar()
                        .then((resultado: Proxy.PrFutbolSala) => {
                            this.datosFutbolSala = resultado;
                            this.MostrarOcultarCarga();
                        })
                        .catch((error) =>
                            this.Error(
                                error,
                                "ERROR al obtener los datos relacionados con la modalidad de Fútbol Sala"
                            )
                        );
                } else {
                    this.MostrarOcultarCarga();
                }
            })
            .catch((error) =>
                this.Error(
                    error,
                    "ERROR al obtener las amonestaciones del equipo actual"
                )
            );

        // Carga de los otros auxiliares y de sus amonestaciones.
        forkJoin([
            this.otrosAuxiliaresService.Lista(
                this.designacion.urlApi,
                this.designacion.idDesignacion,
                this.idEquipo
            ),
            this.otrosAuxiliaresAmonestacionService.listaPorDesignacionYEquipo(
                this.designacion.urlApi,
                this.designacion.idDesignacion,
                this.idEquipo
            ),
        ]).subscribe({
            next: (
                resultado: [
                    mod.ActasParticipacionOtrosAuxiliares[],
                    mod.ActasOtrosAuxiliaresAmonestacion[]
                ]
            ) => {
                console.log("Lista de auxiliares", resultado[0]);
                console.log(
                    "Lista de amonestaciones de auxiliares",
                    resultado[1]
                );
            },
        });
    }

    //#region Métodos del controlador

    public AbrirMenuSecundario(event: any): void {
        let popover: Popover = this.popOverCtrl.create(
            NuevoMenuDerechoComponent
        );

        popover.present({
            ev: event,
        });
    }

    public Cambiando(): void {
        let faltas1: number = parseInt(
            this.datosFutbolSala.faltas1Parte.toString()
        );
        let faltas2: number = parseInt(
            this.datosFutbolSala.faltas2Parte.toString()
        );
        this.acumuladas = faltas1 + faltas2;
    }

    public ActualizarFaltas(form: NgForm): void {
        if (form.valid) {
            this.datosFutbolSala
                .Guardar()
                .then((resultado: Proxy.PrFutbolSala) => {
                    this.datosFutbolSala = resultado;

                    this.Mensaje(
                        "Se ha realizado correctamente la actualización de las faltas acumuladas",
                        4000
                    );
                })
                .catch((error) =>
                    this.Error(error, "ERROR actualizado las faltas acumuladas")
                );
        }
    }

    /**
     * Prepara las variables del controlador para incluir una nueva amonestación, activando el formulario correspondiente para que se pueda indicar los datos necesarios
     * @param datos   Alineado al que se va a amonestar
     */
    public Amonestar(datos: Proxy.PrParticipacion): void {
        this.participante = datos;
        this.mostrarFormulario = true;
        this.mostrarFormularioAuxiliar = false;
        this.codigo = undefined;
        this.amonestacion = new Proxy.PrAmonestaciones(
            this.CFutbolActas,
            this.DBService2,
            this.Persistentes
        );
        this.amonestacion.idDesignacion = this.designacion.idDesignacion;
        this.amonestacion.idEquipo = this.idEquipo;
        this.amonestacion.idJugador = datos.idRegistro;
        this.amonestacion.esIncidencia = this.esIncidencia;
        this.amonestacion.urlApi = this.designacion.urlApi;
        this.amonestacion.urlNombre = this.designacion.urlNombre;

        // Obtención de la licencia relacionada
        this.licencia = this.licencias.AlineablePorIdentificador(
            datos.identificador
        );

        // Scroll al formulario
        let y = document.getElementById("formAmonestacion").offsetTop;
        this.content.scrollTo(0, y);
    }

    public AmonestarOtroAuxiliar(
        participante: mod.ActasParticipacionOtrosAuxiliares
    ): void {
        this.formAuxiliar = new FormGroup({
            minuto: new FormControl("", Validators.required),
            minutoExtra: new FormControl(""),
            anexo: new FormControl(""),
        });

        this.amonestacion = new Proxy.PrAmonestaciones(
            this.CFutbolActas,
            this.DBService2,
            this.Persistentes
        );

        this.codigo = undefined;
        this.mostrarFormulario = false;
        this.mostrarFormularioAuxiliar = true;
        this.participanteAuxiliar = participante;
    }

    /**
     * Indica si la licencia seleccionada en el formulario de incluir amonestación, se encuentra en el terreno de juego.
     * @returns Cadena indicando que el titular o el suplente se encuentra en el terreno de juego.
     */
    EnElTerrenoDeJuego(): string {
        let resultado: string = "";

        if (
            this.amonestacion != null &&
            this.amonestacion.minuto != null &&
            !isNaN(parseInt(this.amonestacion.minuto)) &&
            this.participante != null &&
            this.licencia != null
        ) {
            let valor: string = this.amonestacion.minuto;

            if (
                this.participante.esTitular &&
                this.cambios.TitularEnElTerrenoDeJuego(
                    this.participante.dorsal,
                    valor
                )
            ) {
                resultado = "Titular en el terreno de juego";
            } else if (
                this.participante.esSuplente &&
                this.cambios.SuplenteEnElTerrenoDeJuego(
                    this.participante.dorsal,
                    valor
                )
            ) {
                resultado = "Suplente en el terreno de juego";
            }
        }

        return resultado;
    }

    /**
     * Elimina la amonestación pasada como parámetro
     * @param amonestacion  Datos de la amonestación a eliminar
     */
    public EliminarAmonestado(amonestacion: Proxy.PrAmonestaciones): void {
        let actionSheet: ActionSheet = this.actionSheetCtrl.create({
            title: "Eliminar amonestación",
            subTitle:
                "¿Desea eliminar los datos de la amonestación que ha seleccionado?",
            buttons: [
                {
                    text: "ELIMINAR",
                    handler: () => {
                        this.MostrarOcultarCarga();
                        amonestacion
                            .Eliminar()
                            .then((resultado: boolean) => {
                                this.amonestaciones.lista.forEach(
                                    (
                                        valor: Proxy.PrAmonestaciones,
                                        i: number
                                    ) => {
                                        if (
                                            valor.idAmonestacion ==
                                            amonestacion.idAmonestacion
                                        ) {
                                            this.amonestaciones.lista.splice(
                                                i,
                                                1
                                            );
                                        }
                                    }
                                );
                                console.log(this.amonestaciones.lista);
                                this.MostrarOcultarCarga();
                            })
                            .catch((error) =>
                                this.Error(
                                    error,
                                    "ERROR al eliminar la amonestación"
                                )
                            );
                    },
                },
                {
                    text: "Cancelar",
                    role: "cancel",
                },
            ],
        });
        actionSheet.present();
    }

    /**
     * Elimina una amonestación de un participante auxiliar.
     * @param amonestacion Amonestación a eliminar
     */
    public EliminarAmonestadoAuxiliar(
        amonestacion: mod.ActasOtrosAuxiliaresAmonestacion
    ): void {
        let actionSheet: ActionSheet = this.actionSheetCtrl.create({
            title: "Eliminar amonestación",
            subTitle:
                "¿Desea eliminar los datos de la amonestación que ha seleccionado?",
            buttons: [
                {
                    text: "ELIMINAR",
                    handler: () => {
                        this.MostrarOcultarCarga();

                        this.otrosAuxiliaresAmonestacionService
                            .eliminarAmonestacion(
                                this.designacion.urlApi,
                                amonestacion.id
                            )
                            .subscribe({
                                next: (resultado: boolean) => {
                                    console.log(resultado);
                                },
                                error: (error) => {
                                    this.Error(
                                        error,
                                        "ERROR al eliminar la amonestación"
                                    );
                                    this.MostrarOcultarCarga();
                                },
                                complete: () => this.MostrarOcultarCarga(),
                            });
                    },
                },
                {
                    text: "Cancelar",
                    role: "cancel",
                },
            ],
        });
        actionSheet.present();
    }

    /**
     * Indica si se deben mostrar los demás campos del formulario de inserción de la amonestación.
     * Dependerá de si se ha establecido el minuto y de si es una competición de participación obligatoria.
     * - Para competiciones de participación obligatoria, siempre se deben mostrar todos los campos, ya que no se tiene en cuenta los códigos de no participantes.
     * - Para las otras competiciones, se mostrarán los demás campos cuando se haya indicado el minuto.
     */
    MostrarRestoFormulario(): boolean {
        return (
            this.obligadaParticipacion ||
            (!this.obligadaParticipacion &&
                this.amonestacion != null &&
                this.amonestacion.minuto != null &&
                this.amonestacion.minuto.length > 0)
        );
    }

    public Insertar(form: NgForm): void {
        if (form.valid && this.codigo != null && this.codigo.Id > 0) {
            let tieneAmonestacion: boolean =
                this.amonestaciones.TieneAmonestacion(
                    this.amonestacion.idJugador,
                    this.codigos
                );

            // Insertar la nueva amonestación
            this.MostrarOcultarCarga();
            this.amonestacion
                .Guardar()
                .then((resultado: Proxy.PrAmonestaciones) => {
                    this.amonestaciones.lista.push(resultado);
                    console.log(this.amonestaciones.lista);
                    this.MostrarOcultarCarga();
                    this.mostrarFormulario = false;

                    if (
                        tieneAmonestacion &&
                        this.codigos.EsAmonestacion(
                            this.amonestacion.amonestacion
                        )
                    ) {
                        this.Insertar_dobleAmonestacion(resultado);
                    }
                })
                .catch((error) =>
                    this.Error(
                        error,
                        "ERROR al realizar la inserción de la nueva amonestación."
                    )
                );
        }
    }

    public InsertarAuxiliar(): void {
        try {
            if (this.formAuxiliar.valid) {
                let tieneAmonestacion: boolean =
                    this.otrosAuxiliaresAmonestacionService.tieneAmonestacion(
                        this.participanteAuxiliar.id,
                        this.codigos
                    );

                // Comprueba si se ha seleccionado un código de amonestación
                if (this.codigo == undefined || this.codigo.Id == 0) {
                    this.Error(
                        "Formulario incompleto",
                        "No se ha seleccionado un código de amonestación"
                    );
                    return;
                }

                let datosAmonestacion: mod.ActasOtrosAuxiliaresAmonestacion = {
                    idActaParticipacionOtrosAuxiliares:
                        this.participanteAuxiliar.id,
                    amonestacion: this.codigo.Codigo,
                    minuto: this.formAuxiliar.value.minuto,
                    minutoExtra: this.formAuxiliar.value.minutoExtra,
                    idDesignacion: this.designacion.idDesignacion,
                    idEquipo: this.idEquipo,
                    anexo: this.formAuxiliar.value.anexo,
                    esIncidencia: this.esIncidencia,
                    id: 0,
                };

                this.MostrarOcultarCarga();
                this.otrosAuxiliaresAmonestacionService
                    .guardarAmonestacion(
                        this.designacion.urlApi,
                        datosAmonestacion
                    )
                    .subscribe({
                        next: (
                            resultado: mod.ActasOtrosAuxiliaresAmonestacion
                        ) => {
                            console.log(resultado);

                            this.mostrarFormularioAuxiliar = false;
                            this.mostrarFormulario = false;

                            if (
                                tieneAmonestacion &&
                                this.codigos.EsAmonestacion(
                                    resultado.amonestacion
                                )
                            ) {
                                this.Insertar_dobleAmonestacionAuxiliar(
                                    resultado
                                );
                            }
                        },
                        error: (error) => {
                            this.Error(
                                error,
                                "ERROR al realizar la inserción de la amonestación de otro auxiliar."
                            );
                            this.MostrarOcultarCarga();
                        },
                        complete: () => this.MostrarOcultarCarga(),
                    });
            }
        } catch (error) {
            console.log("Error", error);
        }
    }

    /**
     * Muestra la ventana modal con los códigos de amonestación para que el usuario pueda seleccionar uno
     */
    public VentanaCodigosAmonestacion(): void {
        // Filtrar los códigos de amonestación según la persona está participando o no.
        let codigosAComprobar: Proxy.ListaPrCodigoAmonestacion = Object.assign(
            {},
            this.codigos
        );

        if (!this.obligadaParticipacion) {
            if (
                this.amonestacion != null &&
                this.amonestacion.minuto != null &&
                !isNaN(parseInt(this.amonestacion.minuto)) &&
                this.licencia != null &&
                this.participante != null
            ) {
                let valor: string = this.amonestacion.minuto;

                // El filtrado de códigos a comprobar solamente no se debe realizar para las competiciones de fútbol sala.
                // Tampoco se debe realizar para las competiciones con cambios ilimitados (obligada participación)
                // Solicitud realizada por Miguel Hernández el 22/10/2024

                if (
                    !this.designacion.Configuracion.esFutbolSala &&
                    !this.obligadaParticipacion
                ) {
                    if (
                        (this.participante.esTitular &&
                            !this.cambios.TitularEnElTerrenoDeJuego(
                                this.participante.dorsal,
                                valor
                            )) ||
                        (this.participante.esSuplente &&
                            !this.cambios.SuplenteEnElTerrenoDeJuego(
                                this.participante.dorsal,
                                valor
                            ))
                    ) {
                        codigosAComprobar.lista = this.codigos.lista.filter(
                            (m) => m.noParticipante == true
                        );
                    }
                }
            }
        }

        let modal: Modal = this.modalCtrl.create(ModalCodigoAmonestacionPage, {
            codigos: codigosAComprobar,
        });
        modal.onDidDismiss((data) => {
            if (data != undefined) {
                this.codigo = data;
                this.amonestacion.amonestacion = this.codigo.Codigo;
            }
            //console.log(data);
        });
        modal.present();
    }

    /**
     * Incluye una nueva amonestación, correspondiente a la expulsión por doble amonestación
     * @param datos Amonestación que se acaba de insertar
     */
    private Insertar_dobleAmonestacion(datos: Proxy.PrAmonestaciones): void {
        let actionSheet: ActionSheet = this.actionSheetCtrl.create({
            title: "Doble amonestación",
            subTitle:
                "La persona seleccionada ya tiene una amonestación anterior. ¿Desea aplicarle el código de la doble amonestación?",
            buttons: [
                {
                    text: "Aplicar doble amonestación",
                    handler: () => {
                        let doble: Proxy.PrAmonestaciones =
                            new Proxy.PrAmonestaciones(
                                this.CFutbolActas,
                                this.DBService2,
                                this.Persistentes
                            );

                        doble.amonestacion =
                            this.codigos.CodigoParaDobleAmonestacion().Codigo;
                        doble.anexo = "";
                        doble.esIncidencia = this.esIncidencia;
                        doble.idAmonestacion = 0;
                        doble.idDesignacion = this.designacion.idDesignacion;
                        doble.idEquipo = this.idEquipo;
                        doble.idJugador = datos.idJugador;
                        doble.minuto = datos.minuto;
                        doble.minutoExtra = datos.minutoExtra;
                        doble.urlApi = this.designacion.urlApi;
                        doble.urlNombre = this.designacion.urlNombre;

                        doble
                            .Guardar()
                            .then((resultado: Proxy.PrAmonestaciones) => {
                                this.amonestaciones.lista.push(resultado);
                                this.mostrarFormulario = false;
                            })
                            .catch((error) =>
                                this.Error(
                                    error,
                                    "ERROR al realizar la inserción de la expulsión por doble amonestación."
                                )
                            );
                    },
                },
                {
                    text: "Cancelar",
                    role: "cancel",
                },
            ],
        });
        actionSheet.present();
    }

    /**
     * Incluye una nueva amonestación, correspondiente a la expulsión por doble amonestación
     * @param datos Amonestación que se acaba de insertar
     */
    private Insertar_dobleAmonestacionAuxiliar(
        datos: mod.ActasOtrosAuxiliaresAmonestacion
    ): void {
        let actionSheet: ActionSheet = this.actionSheetCtrl.create({
            title: "Doble amonestación",
            subTitle:
                "La persona seleccionada ya tiene una amonestación anterior. ¿Desea aplicarle el código de la doble amonestación?",
            buttons: [
                {
                    text: "Aplicar doble amonestación",
                    handler: () => {
                        let datosAmonestacion: mod.ActasOtrosAuxiliaresAmonestacion =
                        {
                            idActaParticipacionOtrosAuxiliares:
                                datos.idActaParticipacionOtrosAuxiliares,
                            amonestacion:
                                this.codigos.CodigoParaDobleAmonestacion()
                                    .Codigo,
                            minuto: datos.minuto,
                            minutoExtra: datos.minutoExtra,
                            idDesignacion: this.designacion.idDesignacion,
                            idEquipo: this.idEquipo,
                            anexo: "",
                            esIncidencia: this.esIncidencia,
                            id: 0,
                        };

                        this.otrosAuxiliaresAmonestacionService
                            .guardarAmonestacion(
                                this.designacion.urlApi,
                                datosAmonestacion
                            )
                            .subscribe();
                    },
                },
                {
                    text: "Cancelar",
                    role: "cancel",
                },
            ],
        });
        actionSheet.present();
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./src/pages/amonestaciones/amonestaciones.ts